// RACI rail. Renders the 4 sub-blocks (R/A/C/I) for a task. Read-only
// today (Lane B.1.b will add the picker affordance); pulls owners from
// the canonical lib/owners.ts helpers so legacy single-assigneeId tasks
// render identically to fully-RACI tasks.

import {
  getResponsibles, getAccountable, getConsulted, getInformed,
  ROLE_LABELS, ROLE_DESCRIPTIONS
} from '../lib/owners.ts';
import { MultiOwnerPill } from './MultiOwnerPill.jsx';

const ROLE_ORDER = ['R', 'A', 'C', 'I'];

export const RaciRail = ({ task, staff }) => {
  const byRole = {
    R: getResponsibles(task),
    A: getAccountable(task) ? [getAccountable(task)] : [],
    C: getConsulted(task),
    I: getInformed(task)
  };

  return (
    <div className="raci-rail">
      {ROLE_ORDER.map(role => {
        const owners = byRole[role];
        return (
          <div className={`raci-block raci-block-${role}`} key={role}>
            <div className="raci-block-label" title={ROLE_DESCRIPTIONS[role]}>
              <span className={`raci-role-badge role-${role}`}>{role}</span>
              <span className="raci-role-name">{ROLE_LABELS[role]}</span>
              {owners.length > 0 && (
                <span className="raci-role-count">· {owners.length}</span>
              )}
            </div>
            {owners.length === 0 ? (
              <div className="raci-block-empty">—</div>
            ) : (
              <div className="raci-block-owners">
                {owners.map((o, i) => (
                  <MultiOwnerPill key={`${o.staffId}-${i}`} owner={o} staff={staff} />
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
